import { Card } from '@components/card';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { IntegrationIcon } from 'components/IntegrationIcon';

export const IntegrationHeader = ({ integration }) => {
  return (
    <Card space={6}>
      <Stack space={3}>
        <IntegrationIcon integrationName={integration.name} color="purple100" />
        <div>
          <Text font="bold16" text={integration.title} />
          <Text font="regular14" text={integration.description} />
        </div>
      </Stack>
    </Card>
  );
};
